<template>
  <!--
    	作者：luoyiming
    	时间：2020-06-20
    	描述：diy组件-参数设置-方案栏
    -->
  <div>
    <div class="common-form">
      <span>{{ curItem.name }}</span>
    </div>
    <el-form size="small" :model="curItem" label-width="100px">
      <!--组件样式-->
      <div class="p-10-0 mb16 f14 border-b"><span class="gray6">标题设置</span></div>

      <el-form-item label="组件标题：">
        <el-input v-model="curItem.params.title" class="w-auto" style="width: 50%"/>
      </el-form-item>
      <el-form-item label="标题显示：">
        <el-radio-group v-model="curItem.params.showTitle">
          <el-radio :label="1">不显示</el-radio>
          <el-radio :label="2">显示</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="显示位置：" v-if="curItem.params.showTitle === 2">
        <el-radio-group v-model="curItem.params.titleAlign">
          <el-radio :label="1">居左</el-radio>
          <el-radio :label="2">居中</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="文字颜色：" v-if="curItem.params.showTitle === 2">
        <div class="d-s-c">
          <el-color-picker v-model="curItem.style.titleTextColor"></el-color-picker>
          <el-button type="button" style="margin-left: 10px;"
                     @click.stop="curItem.style.titleTextColor = '#000000'">重置
          </el-button>
        </div>
      </el-form-item>
      <el-form-item label="背景颜色：" v-if="curItem.params.showTitle === 2">
        <div class="d-s-c">
          <el-color-picker v-model="curItem.style.titleBackgroundColor"></el-color-picker>
          <el-button type="button" style="margin-left: 10px;"
                     @click.stop="curItem.style.titleBackgroundColor = '#ffffff'">重置
          </el-button>
        </div>
      </el-form-item>
      <el-form-item label="标题背景图：" style="margin-bottom: 0px" v-if="curItem.params.showTitle === 2">
        <div style="display: inline">
          <div style="height: 60px;display: inline-block">
            <img style="height: 60px;vertical-align: middle" v-img-url="curItem.style.titleBackgroundImage" alt=""
                 @click="$parent.onEditorSelectImage(curItem.style, 'titleBackgroundImage')">
          </div>
          <div style="height: 60px;position: relative;display: inline-block">
            <i class="el-icon-remove" v-if="curItem.style.titleBackgroundImage"
               style="color: red;font-size: 20px;position: absolute;top: -7px;right: -7px;cursor: pointer"
               @click.stop="curItem.style.titleBackgroundImage = ''"></i>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="标题左侧图标：" v-if="curItem.params.showTitle === 2">
        <div class="diy-setpages-cover" style="position: relative;width: 60px;height: 60px">
          <img v-img-url="curItem.style.titleLeftImage" alt=""
               @click="$parent.onEditorSelectImage(curItem.style, 'titleLeftImage')">
          <i class="el-icon-remove" v-if="curItem.style.titleLeftImage"
             style="color: red;font-size: 20px;position: absolute;top: -7px;right: -7px;cursor: pointer"
             @click.stop="curItem.style.titleLeftImage = ''"></i>
        </div>
      </el-form-item>

      <!--组件样式-->
      <div class="p-10-0 mb16 f14 border-b"><span class="gray6">数据设置</span></div>

      <el-form-item label="方案来源：">
        <el-radio-group v-model="curItem.params.source">
          <el-radio :label="'auto'">自动获取</el-radio>
          <el-radio :label="'choice'">手动选择</el-radio>
        </el-radio-group>
      </el-form-item>
      <!-- 自动获取 -->
      <template v-if="curItem.params.source == 'auto'">
        <!-- 方案分类 -->
        <el-form-item label="方案分类：" v-if="curItem.params.source == 'auto'">
          <el-cascader
            class="ww100" style="width: 50%"
            v-model="currCategory"
            v-if="CategoryList.length > 0"
            ref="cascader"
            clearable
            :options="CategoryList"
            :props="{ checkStrictly: true, children: 'children', value: 'id', label: 'typeName' }"
            @change="changeCategory"
          ></el-cascader>
          <el-button type="button" style="margin-left: 10px;"
                     @click.stop="resetCategory">重置
          </el-button>
        </el-form-item>
        <!-- 显示数量 -->
        <el-form-item label="显示数量：">
          <el-input v-model="curItem.params.auto.showNum" class="w-auto" style="width: 50%"></el-input>
        </el-form-item>
      </template>
      <!-- 手动选择 -->
      <template v-if="curItem.params.source == 'choice'">
        <el-form-item label="方案列表：">
          <div class="choice-product-list">
            <draggable v-model="curItem.data" :options="{draggable:'.item',animation:500}">
              <transition-group class="d-s-c f-w">
                <div v-for="(product, index) in curItem.data" class="item" :key="product.productId">
                  <div class="delete-box"><i class="el-icon-error"
                                             @click="$parent.onEditorDeleleData(index, selectedIndex)"></i></div>
                  <img v-img-url="product.image" alt=""/>
                </div>
              </transition-group>
            </draggable>
          </div>
          <div>
            <el-button icon="el-icon-plus" @click.stop="$parent.openSolution(curItem.data,true)">选择方案</el-button>
          </div>
        </el-form-item>
      </template>

      <!--组件样式-->
      <div class="p-10-0 mb16 f14 border-b"><span class="gray6">组件样式</span></div>

      <!-- 背景颜色 -->
      <el-form-item label="背景颜色：">
        <div class="d-s-c">
          <el-color-picker v-model="curItem.style.background"></el-color-picker>
          <el-button type="button" style="margin-left: 10px;"
                     @click.stop="$parent.onEditorResetColor(curItem.style, 'background', '#ffffff')">重置
          </el-button>
        </div>
      </el-form-item>

      <!-- 方案排序 -->
      <el-form-item label="样式排列：">
        <el-radio-group v-model="curItem.style.display">
          <el-radio :label="'list'">列表平铺</el-radio>
          <el-radio :label="'slide'" :disabled="curItem.style.column == 1">横向滑动</el-radio>
        </el-radio-group>
      </el-form-item>
      <!-- 方案排序 -->
      <el-form-item label="分列数量：">
        <el-radio-group v-model="curItem.style.column">
          <el-radio :label="1" :disabled="curItem.style.display == 'slide'">单列</el-radio>
          <el-radio :label="2">两列</el-radio>
          <el-radio :label="3">三列</el-radio>
        </el-radio-group>
      </el-form-item>
      <!-- 方案排序 -->
      <el-form-item label="显示内容：">
        <el-checkbox v-model="productNameShow" @change="checked => check(checked, 'productName')">方案名称</el-checkbox>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import CropSolutionApi from '@/api/cropsolution.js'

export default {
  data () {
    return {
      /*是否正在加载*/
      loading: true,
      /*方案类别*/
      CategoryList: [],
      /*当前选中的*/
      currCategory: [],
      productNameShow: false,
      productPriceShow: false,
      linePriceShow: false,
      sellingPointShow: false,
      productSalesShow: false,
      currGroup: [],
      groupProductList: []
    }
  },
  props: ['curItem', 'selectedIndex', 'opts'],
  created () {
    /*获取列表*/
    this.getData()
    this.productNameShow = this.curItem.style.show.productName == 1 ? true : false
    this.productPriceShow = this.curItem.style.show.productPrice == 1 ? true : false
    this.linePriceShow = this.curItem.style.show.linePrice == 1 ? true : false
    this.sellingPointShow = this.curItem.style.show.sellingPoint == 1 ? true : false
    this.productSalesShow = this.curItem.style.show.productSales == 1 ? true : false
  },
  watch: {
    selectedIndex: function (n, o) {
      if (this.curItem.params.source == 'auto') {
        this.currCategory = this.currCategoryAuto(this.CategoryList)
      }
    }
  },
  methods: {
    /*获取方案*/
    getData () {
      let self = this
      CropSolutionApi.getCropSolutionType({}, true).then(res => {
        self.CategoryList = res.data
        self.currCategory = self.currCategoryAuto(res.data)
        self.loading = false
      }).catch(error => {
        self.loading = false
      })
    },

    /*选择默认*/
    currCategoryAuto (list) {
      let arr = this.getArrList(list)
      return arr.reverse()
    },
    currGroupAuto (list) {
      let arr = this.getGroupArrList(list)
      return arr.reverse()
    },
    getArrList (list) {
      let arr = []
      for (let i = 0; i < list.length; i++) {
        let item = list[i]
        if (item.id === this.curItem.params.auto.category) {
          arr.push(item.id)
          break
        } else {
          if (Object.prototype.toString.call(item.children) === '[object Array]' && item.children.length > 0) {
            arr = this.getArrList(item.children)
            if (arr && arr.length) {
              arr.push(item.id)
              break
            }
          }
        }
      }
      return arr
    },
    getGroupArrList (list) {
      let arr = []
      for (let i = 0; i < list.length; i++) {
        let item = list[i]
        if (item.id === this.curItem.params.auto.category) {
          arr.push(item.id)
          break
        } else {
          if (Object.prototype.toString.call(item.children) === '[object Array]' && item.children.length > 0) {
            arr = this.getGroupArrList(item.children)
            if (arr && arr.length) {
              arr.push(item.id)
              break
            }
          }
        }
      }
      return arr
    },
    /*检查*/
    check (checked, name) {
      let value = checked ? 1 : 0
      this.curItem.style.show[name] = value
    },

    /*选择类别*/
    changeCategory (e) {
      let item = this.$refs['cascader'].getCheckedNodes()
      if (item && item.length) {
        this.curItem.params.auto.category = item[0].data.categoryId
      } else {
        this.curItem.params.auto.category = 0
      }
    },
    resetCategory () {
      this.currCategory = []
      this.curItem.params.auto.category = 0
    },
    changeGroup (e) {
      let item = this.$refs['groupcascader'].getCheckedNodes()
      if (item && item.length) {
        this.curItem.params.auto.category = item[0].data.id
      } else {
        this.curItem.params.auto.category = 0
      }
    },
    resetGroup () {
      this.currGroup = []
      this.curItem.params.auto.category = 0
    },
  }
}
</script>

<style>
.choice-product-list {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.choice-product-list .item {
  position: relative;
  width: 80px;
  height: 80px;
  margin-right: 10px;
  margin-bottom: 10px;
  border: 1px solid #dddddd;
}

.choice-product-list .item .delete-box {
  position: absolute;
  width: 20px;
  height: 20px;
  top: -10px;
  right: -10px;
  font-size: 20px;
  cursor: pointer;
  color: #999999;
}

.choice-product-list .item .delete-box:hover {
  color: rgb(255, 51, 0);
}

.choice-product-list .item.plus-btn {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.choice-product-list .item.plus-btn > i {
  font-size: 30px;
  color: #cccccc;
}

.choice-product-list img {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/page/page/diy/params/CropSolution.vue